module.exports = __webpack_public_path__ + "static/media/text_4.c22d2c4e.png";